<!-- <table mat-table class="mat-elevation-z8 offset-lg-1"> -->
    <!-- {{successMessage}} -->
    <app-header-latest></app-header-latest>
    <!-- <div>HIII</div> -->
    <!-- <ng-container *ngIf="true"> -->
        @if (successMessage) {
        <div class="col-lg-12" >
            <div class="row">
                <div class="col-md-12">
                    <div class="error-section">
                        <div class="images">
                            <div class="custom-icon">
                                <p class="check-mark "><i class="fa-solid fa-circle-check"></i></p>
                            </div>
                        </div>
                        <h3>Verified</h3>
                        <h3>{{statusMessage}}</h3>
                    </div>
                </div>
            </div>
        </div>
    }@else{
        <div class="col-lg-12" >
            <div class="row">
                <div class="col-md-12">
                    <div class="error-section">
                        <div class="images">
                            <div class="custom-icon">
                                <!-- <i class=" fa fa-check-circle"
                                        style="color: var(--primary-color);font-size: 45px;"></i> -->
                                <!-- <img src="assets/images/verified.gif" alt="" height="100" width="100"> -->
                            </div>
                        </div>
                        <h2>Error</h2>
                        <h3>Some technical error. Please try again.</h3>
                        <!-- hiiii -->
                    </div>
                </div>
            </div>
        </div>
    }
    <!-- </ng-container> -->
    <div class="gray-bg py-0">
        <app-our-apps></app-our-apps>
      </div>
      
      <app-footer-more-info></app-footer-more-info>
    <!-- </table> -->
    
    <!-- <div>
        <div>
    
        </div>
    </div> -->